/// <reference types="@types/googlemaps" />

import {MapsAPILoader} from '@agm/core';
import {Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'places-autocomplete',
  templateUrl: './places-autocomplete.component.html',
  styleUrls: ['./places-autocomplete.component.scss']
})
export class GooglePlacesComponent implements OnInit {

  @Input() hint: 'Select a location nearest to you';
  @Output() placeChanged: EventEmitter<any> = new EventEmitter();
  @ViewChild('search') public searchElementRef: ElementRef;
  public searchControl: FormControl;
  public latitude = 0;
  public longitude = 0;
  public address = '';
  public hasLocation = false;
  private pristine = true;


  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.searchControl = new FormControl();

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: []
      });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (!place.geometry) {
            this.latitude = 0;
            this.longitude = 0;
            this.hasLocation = false;
          } else {
            this.latitude = place.geometry.location.lat();
            this.longitude = place.geometry.location.lng();
            this.address = this.searchElementRef.nativeElement.value;
            this.hasLocation = true;
          }
          this.pristine = false;
          this.placeChanged.emit();
        });
      });
    });
  }

  onBlur(): void {
    this.pristine = false;
    const newAddress: string = this.searchElementRef.nativeElement.value;
    if (newAddress.length < 1 || newAddress !== this.address) {
      this.latitude = 0;
      this.longitude = 0;
      this.hasLocation = false;
    }
    this.placeChanged.emit();
  }

  public reset(): void {
    this.latitude = 0;
    this.longitude = 0;
    this.address = '';
    this.searchElementRef.nativeElement.value = '';
    this.hasLocation = false;
    this.pristine = true;
  }

  public isEmpty(): boolean {
    return this.searchElementRef.nativeElement.value.length < 1;
  }

  public isPristine(): boolean {
    return this.pristine;
  }
}

